import React from 'react';
import JoinOurCommunity from '../TippingArticles/JoinOurCommunity';

import styles from './index.module.scss';
import ContactForm from './Form';
import FollowUs from '../../Common/FollowUs';

export default function ContactUsContent(): React.ReactElement {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.form}>
              <ContactForm />
            </div>
            <div className={styles.contactTitle}>
              <div className={styles.title}>
                <h1>Contact Us</h1>
                <span>
                  We’re here to answer your questions and provide support.
                  Let us know how we can assist you!
                </span>
              </div>
              <div className={styles.follow}>
                <FollowUs />
              </div>
            </div>
          </div>
        </div>
      </div>
      <JoinOurCommunity />
    </>
  );
}
